import { Pill } from "@clipboard-health/ui-components";

import { DOUBLE_GRADIENT } from "./constants";

export function ShiftDoublePill() {
  return (
    <Pill
      size="small"
      variant="filled"
      label="Double available"
      iconType="block-shift"
      sx={{ width: "fit-content", background: DOUBLE_GRADIENT }}
    />
  );
}
